import { FC } from 'react';
import { useParams } from 'react-router';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useGetComponentsPageQuery } from '@/modules/Pages';

interface Props {
  items: BaseQueryParams<typeof useGetComponentsPageQuery>['data'];
}

export const PageComponentsOverviewView: FC<Props> = ({ items }) => {
  const componentId = useParams()['*']?.replace('components/', '').replace('/edit', '').replace('/create', '');

  return (
    <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 55px - 56px - 48px - 48px)' }}>
      <AppCardList
        headerTitle="Компоненти"
        rowKey="id"
        titleKey="name"
        selectedKey={ componentId }
        navigateTo={ ({ id, site: { id: siteId } }) => ({
          to: AppRoutes.PageComponentsById.replace(':siteId', siteId).replace(':componentId', id),
          replace: componentId === id,
        }) }
        list={ items }
      />
      { /* <List
        dataSource={ items }
        renderItem={ (item) => (
          <List.Item>
            <Link
              style={{ width: '100%' }}
              to={ AppRoutes.PageLayoutsById.replace(':siteId', item.site.id).replace(':componentId', item.id) }
            >
              <Card title={ item.name } extra={ <>dwdwds</> }/>
            </Link>
          </List.Item>
        ) }
      /> */ }
    </div>
  );
};
